export default ({}) => {
    return {
        chart: {
            animation: false,
        },
        plotOptions: {
            series: {
                animation: false,
            },
        },
    };
};
